import { type FC } from 'react';
import ModalTitle, { type ModalTitleProps } from './ModalTitle';
import { useSuspenseQuery } from '@apollo/client';
import { GET_USER_MODAL_TITLE } from '@/graphql/querys/getUserModalTitle';
import { Box, Typography } from '@mui/material';

interface Props extends ModalTitleProps {
  userId: number;
}

export const UserModalTitle: FC<Props> = ({ userId, ...modalTitleProps }) => {
  const { data } = useSuspenseQuery(GET_USER_MODAL_TITLE, {
    variables: {
      userId,
    },
  });

  return (
    <ModalTitle
      {...modalTitleProps}
      title={data.user.fullName}
      subtitle={
        <Box display="flex" gap={2}>
          <Typography variant="subtitle2">
            <Typography component="span" color="text.secondary">
              ID:{' '}
            </Typography>
            {data.user.id}
          </Typography>
          <Typography>
            <Typography component="span" color="text.secondary">
              Email:{' '}
            </Typography>
            {data.user.email}
          </Typography>
        </Box>
      }
    />
  );
};
